import { Component, ElementRef } from '@angular/core';
import { NotesService } from '../../core/service';

@Component({
  selector: 'app-notes-service',
  template: '',
  standalone: true
})
export class NotesServiceComponent  {

  constructor(
    private element: ElementRef,
    service: NotesService) {
      this.element.nativeElement.service = service;
  }
}
